<p-dialog
  [header]="getHeader()"
  [(visible)]="visible"
  [style]="{ width: '100%', maxWidth: '1000px' }"
  [contentStyle]="{ minHeight: 'calc(100vh - 750px)' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [focusOnShow]="false"
>
  <div class="flex flex-column gap-3">
    <eo-form
      #eoForm
      [config]="getFormConfig()"
      (formSubmit)="onSubmit($event)"
      [submitButtonLoading]="isSubmitLoading()"
      [customFormControls]="{ hospital: hospital }"
    >
      <ng-template
        #hospital
        let-formGroup="formGroup"
        let-config="config"
        let-styleClass="styleClass"
      >
        <ng-container [formGroup]="formGroup">
          <app-hospital-dropdown
            *ngIf="isHospitalDropdownVisible()"
            [label]="config.label"
            [class]="styleClass"
            [config]="config"
            formControlName="hospital"
            placeholder="Επιλέξτε Νοσοκομείο"
          />
        </ng-container>
      </ng-template>
    </eo-form>
  </div>
</p-dialog>
